<!-- 添加邮件抽屉页面 -->
<template>
    <div class="drawer-page" v-if="isShow">
        <div class="drawer-page-title">{{$t('language.addEmail.connectDesc')}}</div>
        <!-- 邮件列表 -->
        <div class="drawer-page-body">
            <div class="add-txt">{{$t('language.addEmail.peEmail')}}</div>
            <el-scrollbar style='height:100%;' ref="pageScrollbar">
                <div class="drawer-page-add-body">
                    <!-- 邮件实例 -->
                    <div class="drive-add-cloud" :key="index" v-for="(item,index) in addEmailLine" @click="addEmailDialog(item)">
                        <div class="add-cloud-item">
                            <div class='add-cloud-center'>
                                <div class="cloud cloud-size cloudPosition" :class="item.appName"></div>
                                <div class="add-cloud-item-name">{{$t('language.addCloud.'+item.appName)}}</div>
                                <div class="add-cloud-item-name add-cloud-item-name-coming" style="padding:0;"></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="drive-add-cloud" :key="index" v-for="(item,index) in otherEmailLine">
                            <div class="add-cloud-item">
                                <div class='add-cloud-center'>
                                    <div class="cloud cloud-size cloudPosition" :class="item.icon"></div>
                                    <div class="add-cloud-item-name">{{item.appName}}</div>
                                    <div class="add-cloud-item-name add-cloud-item-name-coming">{{$t('language.addCloud.comingSoon')}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
        <addCloudDialog ref="addCloudDialog"></addCloudDialog>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import addCloudDialog from '@/components/popup/add_cloud_popups/add_cloud_popup';
export default {
    name: "darwerAddEmailPage",
    components: {
        addCloudDialog,
    },
    data() {
        return {
            isShow: false,
            addEmailLine: [],//email集合
            otherEmailLine: [{appName: "Office 365 Mail",icon:"officeMail"}],//之后再行添加的email集合
        }
    },
    mounted() {
        this.getEmailsLine();
    },
    methods: {
        init() {
            //触发初始化和动画
            this.isShow = true;
            if(!this.addEmailLine||this.addEmailLine.length<1){
                this.getEmailsLine();
            }
        },
        getEmailsLine () {
            //获取云盘种类并存储在store中
            let addEmailLine = [];
            let CategoriesAll = commonstate.cloudCategories;
            for(var i=0;i<CategoriesAll.length;i++){
                var item = CategoriesAll[i];
                if(commonstate.emailClouds.includes(item.appName)){
                    addEmailLine.push(item);
                }
            }
            this.addEmailLine = addEmailLine;
        },
        //打开添加云盘弹窗
        addEmailDialog (item) {
            let that = this;
            let redirectUrl = commonstate.addFromEmailTransRedirectUrl;
            let user = commonUtils.getUser();
            let name = this.$t('language.addCloud.'+item.appName).trim().replace(/\s+/ig, " ");
            let allDrives = Object.assign([], this.$store.getters.getUsersDrives);
            let nameArr = [];
            $.each(allDrives, function (i, item) {
                nameArr.push(item.name);
            });
            commonUtils.includesDriveName(nameArr, name, that);
            let addData = new addCloudUtils.addCloudData(user.id, that.reName, null, null, null, null, null, null, item.appName, null, null, redirectUrl);
            //请求后端数据
            this.Utils.doDrivesRequest("add", addData).then(res => {
                if (res.status == 201) {//打开第三方网页
                    var allDrives = Object.assign([], this.$store.getters.getUsersDrives);
                    localStorage.setItem(user.id+'driveNum',allDrives.length);//用户的云盘列表长度
                    that.Utils.openNewWin(res);
                }else{
                    if(res.status == 401){
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "emailTransfer"
                        });
                    }
                }
            });
        },
    },
}
</script>
<style scoped>
.add-cloud-item-name-coming {
    background: #E4E7F3;
    border-radius: 9px;/*no*/
    width: fit-content !important;
    padding: 0 10px;/*no*/
    height: 20px !important;/*no*/
    line-height: 20px;/*no*/
}

.drawer-page {
    padding-left: 40px;/*no*/
    width: 55vw;
    height: 100%;
}

.drawer-page-title {
    line-height: 80px;/*no*/
    font-size: 26px;/*no*/
    font-family: Arial;
    font-weight: bold;
    color: #262833;
}

.drawer-page-body {
    width: calc(100% - 80px);/*no*/
    height: calc(100% - 150px);/*no*/
    background: #F5F6FA;
    border-radius: 8px;/*no*/
    padding: 40px 0;/*no*/
    position: relative;
}

.drawer-page-add-body {
    padding: 0 20px;/*no*/
}

/*云盘添加列表界面*/
.drive-add-cloud {
    width: 18%;
    margin: 0 1%;
    float: left;
    color: rgba(0, 0, 0, 0.6);
    height: 130Px;
    background: #FFFFFF;
    border: 1Px solid #e4e9f3;/*no*/
    border-radius: 4px;/*no*/
}

.drive-add-cloud:hover {
    box-shadow: unset !important;
    background: #FFFFFF;
    /* border-radius: 3px; */
}

.add-cloud-item {
    display: flex;
    align-items: center;
    justify-content: center;
}

.add-cloud-item-name {
    width: 100%;
    height: 20%;
    font-size: 14px;
    /*no*/
    text-align: center;
    margin: auto;
    margin-top: 5Px;
    float: none !important;
    font-family: Roboto Medium;
}

.cloudPosition {
    position: relative;
    top: 5px;
    /*no*/
}

.add-txt{
    position: absolute;
    font-weight:bold;
    top: 15Px;
    left: 15Px;
}

.btn-brd-gry {
    border: 1px solid #ccc;/*no*/
    border-radius: 10px;/*no*/
    height: 34px;/*no*/
    line-height: 34px;/*no*/
    background: 0 0;
    color: #000;
    font-size: 14px!important;/*no*/
    font-family: Roboto-Regular,Roboto;
    font-weight: 400;
    padding: 0 8px;/*no*/
}

.btn-brd-gry:hover {
    box-shadow: 0px 2px 8px rgba(62,70,120,0.46);
}

.google-small {
    width: 18px;/*no*/
    height: 18px;/*no*/
    margin-right: 10px;/*no*/
    background: url("https://www.multcloud.com/assets/images/sign/MC-signup-ic-log-google-small.svg") no-repeat;
    display: inline-block;
    vertical-align: middle;
    margin-left: 0;
}

.gmail-88 {
  width: 60px !important;/*no*/
  height: 45px !important;/*no*/
  background: url("../../../assets/images/vectorImg/icon-gmail-88.svg") no-repeat !important;
  margin-bottom: 10px;/*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/drawer/page/add_email.vue